import React from 'react';

export default class CommonClientScripts extends React.Component {

  render() {
    // const reactJs = (this.props.prod === true) ? 'react-with-addons.min.js' : 'react-with-addons.js';
    // const reactDomJs = (this.props.prod === true) ? 'react-dom.min.js' : 'react-dom.js';

    return (
      <div>
        {/* <script src="https://code.jquery.com/jquery-3.1.0.min.js"></script> */}
        {/* <script src={`/assets/js/vendor/${reactJs}`}></script> */}
        {/* <script src={`/assets/js/vendor/${reactJs}`}></script>
        <script src={`/assets/js/vendor/${reactDomJs}`}></script> */}
        <script src="../assets/js/vendor/jquery-3.1.0.min.js"></script>
        <script src="../assets/js/vendor/react-with-addons.js"></script>
        <script src="../assets/js/vendor/react-dom.min.js"></script>
        <script src="../assets/js/vendor/countUp.min.js"></script>
        <script src="../assets/js/vendor/jquery.waypoints.min.js"></script>
        <script src="../assets/js/vendor/fitie.js"></script>
        <div dangerouslySetInnerHTML={ { __html: this.getFlexibilityPolyfill() } }></div>
      </div>
    );
  }

  getFlexibilityPolyfill() {
    return '<!--[if IE 9]><script src="../assets/js/vendor/flexibility.js"></script><![endif]-->';
  }

};
